<template>
    <div class="main pb-24 container mx-auto">
        <div class="w-full max-w-xs mx-auto">
            <h1 class="text-center p-5 pt-10 md:pt-16">{{ $t('LOGIN_LOG_IN') }}</h1>
            <login-form></login-form>
        </div>
    </div>
</template>

<script>
import LoginForm from '@/components/forms/auth/LoginForm';

export default {
    name: 'Login',
    components: { LoginForm },
    mounted() {
        this.$store.dispatch('auth/resetAuth');
        this.$store.dispatch('account/resetAccount');
    },
};
</script>
